import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { LogoComponent } from '../logo/logo.component';

interface FoodServiceStatus {
    isActive: boolean;
    title: string;
    description: string;
}

@Component({
  selector: 'app-create-menu-button',
  imports: [LogoComponent],
  templateUrl: './create-menu-button.component.html',
  styleUrl: './create-menu-button.component.scss',
})
export class CreateMenuButtonComponent {
  popupIsOpen: boolean = false;
  serviceStatusData: FoodServiceStatus|null = null;

  async ngOnInit() {
    this.serviceStatusData = await this.readFoodServiceStatus();
  }

  goToApp() {
    if(this.serviceStatusData?.isActive) {
      window.open(environment.appUrl + 'pet-diet', '_blank');
    } else {
      this.popupIsOpen = true;
    }
  }

  close() {
    this.popupIsOpen = false;
  }

  async readFoodServiceStatus(): Promise<FoodServiceStatus> {
    try {
      const response = await fetch(
        environment.apiUrl +
        environment.apiVersion +
        '/food/read-state',
        {
          method: 'GET'
        }
      );

      if (!response.ok) {
        const errorBody = await response.json();
        throw new Error(errorBody?.message || 'Errore HTTP');
      }

      const data = await response.json();
      return data.body;
    } catch (error) {
      console.error('Errore nella richiesta dello stato del servizio:', error);
      return {isActive: false, title: 'Servizio non disponibile', description: 'Il servizio di creazione menu è attualmente non disponibile. Riprova più tardi.'};
    }
  }
}
